import { createContext, useContext, useState, useEffect } from "react";

const I18nContext = createContext(null);

const dict = {
  en: {
    "nav.home": "Home",
    "nav.programs": "Programs",
    "nav.destinations": "Destinations",
    "nav.about": "About",
    "nav.contact": "Contact",
    "cta.free_consultation": "Free Consultation",
    "cta.book_consultation": "Book Free Consultation",
    "cta.whatsapp": "WhatsApp Us",
    "cta.call": "Call",
    "cta.talk_agent": "Talk to an Agent",
    "cta.get_details": "Get details",
    "cta.next": "Next",
    "cta.back": "Back",
    "cta.submit_inquiry": "Submit inquiry",
    "cta.book_free": "Book free consultation",
    "cta.all_programs": "All programs",
    "hero.tag": "QEAC Certified • Brazil to Australia",
    "hero.title_1": "Study & Work in",
    "hero.title_2": "Australia.",
    "hero.title_3": "Your global journey",
    "hero.title_4": "starts here.",
    "hero.subtitle": "World-class education, vibrant cities and unforgettable experiences — guided by certified agents who treat your dream like their own.",
    "stat.students": "Students Placed",
    "stat.partners": "Partner Schools",
    "stat.years": "Years of Expertise",
    "stat.success": "Visa Success Rate",
    "stat.personal": "Personalised Service",
    "stat.certified": "Certified Agency",
    "stat.many": "Many",
    "stat.network": "School Network",
    "stat.network_num": "Nationwide",
    "scroll": "Scroll",
    "quote.text": "The world is like a book, and those who do not travel read only one page.",
    "quote.author": "— Saint Augustine",
    "programs.eyebrow": "Our Programs",
    "programs.title": "Choose your path to a global future.",
    "why.eyebrow": "Why Go Global Now",
    "why.title_1": "Your success is our",
    "why.title_2": "obsession.",
    "why.body": "We don't just place students — we craft journeys. With QEAC certified agents and a Brazil-to-Australia network, we walk with you every step.",
    "why.qeac_title": "QEAC Certified Agents",
    "why.qeac_desc": "Government-recognised qualifications for ethical, expert advice.",
    "why.personal_title": "Personalised Support",
    "why.personal_desc": "One agent, end-to-end — from course selection to your arrival in Australia.",
    "why.ethical_title": "Ethical Guidance",
    "why.ethical_desc": "We recommend what's right for you, not what pays us most.",
    "dest.eyebrow": "Top 5 Destinations",
    "dest.title": "Find your Australian home.",
    "test.eyebrow": "Success Stories",
    "test.title": "Real students. Real journeys. Real outcomes.",
    "faq.eyebrow": "Frequently Asked",
    "faq.title": "Questions, answered.",
    "cta_final.title_1": "Your future in Australia",
    "cta_final.title_2": "is one conversation away.",
    "cta_final.body": "Book a free consultation with a QEAC certified agent and find your perfect pathway.",
    "footer.programs": "Programs",
    "footer.destinations": "Destinations",
    "footer.contact": "Contact",
    "footer.tagline": "QEAC certified education agents connecting Brazilian students with world-class study opportunities in Australia.",
    "footer.rights": "All rights reserved.",
    "footer.cert": "QEAC Certified • Registered Education Agents",
    "contact.eyebrow": "Get in Touch",
    "contact.title_1": "Let's start your",
    "contact.title_2": "journey.",
    "contact.visit": "Visit",
    "contact.call": "Call",
    "contact.email": "Email",
    "contact.whatsapp_label": "WhatsApp",
    "contact.whatsapp_sub": "Instant reply",
    "inq.step": "Step",
    "inq.of": "of",
    "inq.title": "Student inquiry",
    "inq.full_name": "Full name *",
    "inq.email": "Email *",
    "inq.phone": "Phone *",
    "inq.country": "Country",
    "inq.program": "Program of interest *",
    "inq.destination": "Preferred destination",
    "inq.english": "English level",
    "inq.intake": "Preferred intake",
    "inq.intake_ph": "e.g. February 2026",
    "inq.message": "Anything else we should know?",
    "inq.message_ph": "Goals, budget, questions...",
    "inq.success_title": "You're all set",
    "inq.success_body": "A QEAC certified agent will contact you within 24 hours.",
    "cons.eyebrow": "Free Consultation",
    "cons.title": "Book a 30-minute call",
    "cons.pick_date": "Pick a date",
    "cons.pick_time": "Pick a time (AEST)",
    "cons.success_body": "We'll send confirmation details to",
  },
  pt: {
    "nav.home": "Início",
    "nav.programs": "Cursos",
    "nav.destinations": "Destinos",
    "nav.about": "Sobre",
    "nav.contact": "Contato",
    "cta.free_consultation": "Consultoria Grátis",
    "cta.book_consultation": "Agende uma Consultoria Grátis",
    "cta.whatsapp": "Fale no WhatsApp",
    "cta.call": "Ligar",
    "cta.talk_agent": "Fale com um Agente",
    "cta.get_details": "Saiba Mais",
    "cta.next": "Próximo",
    "cta.back": "Voltar",
    "cta.submit_inquiry": "Enviar pedido",
    "cta.book_free": "Agendar consultoria grátis",
    "cta.all_programs": "Todos os cursos",
    "hero.tag": "Certificado QEAC • Do Brasil para a Austrália",
    "hero.title_1": "Estude e Trabalhe na",
    "hero.title_2": "Austrália.",
    "hero.title_3": "Sua jornada global",
    "hero.title_4": "começa aqui.",
    "hero.subtitle": "Educação de classe mundial, cidades vibrantes e experiências inesquecíveis — guiado por agentes certificados que tratam seu sonho como o próprio.",
    "stat.students": "Estudantes Atendidos",
    "stat.partners": "Escolas Parceiras",
    "stat.years": "Anos de Experiência",
    "stat.success": "Taxa de Sucesso de Visto",
    "stat.personal": "Atendimento Personalizado",
    "stat.certified": "Agência Certificada",
    "stat.many": "Várias",
    "stat.network": "Rede de Escolas",
    "stat.network_num": "Nacional",
    "scroll": "Role",
    "quote.text": "O mundo é como um livro, e quem não viaja lê apenas uma página.",
    "quote.author": "— Santo Agostinho",
    "programs.eyebrow": "Nossos Programas",
    "programs.title": "Escolha seu caminho para um futuro global.",
    "why.eyebrow": "Por que a Go Global Now",
    "why.title_1": "Seu sucesso é a nossa",
    "why.title_2": "obsessão.",
    "why.body": "Não apenas matriculamos estudantes — criamos jornadas. Com agentes certificados QEAC e uma rede Brasil-Austrália, caminhamos com você em cada passo.",
    "why.qeac_title": "Agentes Certificados QEAC",
    "why.qeac_desc": "Qualificações reconhecidas pelo governo para orientação ética e especializada.",
    "why.personal_title": "Atendimento Personalizado",
    "why.personal_desc": "Um agente, do início ao fim — da escolha do curso até sua chegada na Austrália.",
    "why.ethical_title": "Orientação Ética",
    "why.ethical_desc": "Recomendamos o que é certo pra você, não o que mais nos paga.",
    "dest.eyebrow": "Top 5 Destinos",
    "dest.title": "Encontre seu lar na Austrália.",
    "test.eyebrow": "Histórias de Sucesso",
    "test.title": "Estudantes reais. Jornadas reais. Resultados reais.",
    "faq.eyebrow": "Perguntas Frequentes",
    "faq.title": "Suas dúvidas, respondidas.",
    "cta_final.title_1": "Seu futuro na Austrália",
    "cta_final.title_2": "está a uma conversa de distância.",
    "cta_final.body": "Agende uma consultoria grátis com um agente certificado QEAC e descubra seu caminho ideal.",
    "footer.programs": "Cursos",
    "footer.destinations": "Destinos",
    "footer.contact": "Contato",
    "footer.tagline": "Agentes de educação certificados QEAC conectando estudantes brasileiros a oportunidades de estudo de classe mundial na Austrália.",
    "footer.rights": "Todos os direitos reservados.",
    "footer.cert": "Certificado QEAC • Agentes de Educação Registrados",
    "contact.eyebrow": "Entre em Contato",
    "contact.title_1": "Vamos começar sua",
    "contact.title_2": "jornada.",
    "contact.visit": "Visite",
    "contact.call": "Ligue",
    "contact.email": "E-mail",
    "contact.whatsapp_label": "WhatsApp",
    "contact.whatsapp_sub": "Resposta instantânea",
    "inq.step": "Passo",
    "inq.of": "de",
    "inq.title": "Inscrição do estudante",
    "inq.full_name": "Nome completo *",
    "inq.email": "E-mail *",
    "inq.phone": "Telefone *",
    "inq.country": "País",
    "inq.program": "Curso de interesse *",
    "inq.destination": "Destino preferido",
    "inq.english": "Nível de inglês",
    "inq.intake": "Mês de entrada preferido",
    "inq.intake_ph": "ex: Fevereiro 2026",
    "inq.message": "Algo mais que devemos saber?",
    "inq.message_ph": "Objetivos, orçamento, dúvidas...",
    "inq.success_title": "Tudo certo",
    "inq.success_body": "Um agente certificado QEAC entrará em contato em 24 horas.",
    "cons.eyebrow": "Consultoria Grátis",
    "cons.title": "Agende uma ligação de 30 minutos",
    "cons.pick_date": "Escolha uma data",
    "cons.pick_time": "Escolha um horário (AEST)",
    "cons.success_body": "Enviaremos os detalhes de confirmação para",
  },
};

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ggn_lang") || "en");
  useEffect(() => {
    localStorage.setItem("ggn_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (k) => dict[lang]?.[k] || dict.en[k] || k;
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
